import { Injectable } from '@angular/core';
import { SocketMessage } from 'src/app/system/utility/websocket.service';
import { logger } from '../logging/logging.service';
import { QueueDispatcherService } from './queue-dispatcher.service';
import { SocketChannel } from './socket-message.bean';
import { HelpDeskDispatcherService } from './helpdesk-dispatcher.service';

@Injectable({
  providedIn: 'root'
})
export class SocketMessageService {

  private callbackMap: Map<SocketChannel, Function> = new Map<SocketChannel, Function>();

  // Register all the Message Dispatcher here
  constructor(
    srvQueueDispatcher: QueueDispatcherService,
    srvHelpdeskDispatcher: HelpDeskDispatcherService,
  ) {
    this.callbackMap.set(SocketChannel.QUEUE, srvQueueDispatcher.handleMessage.bind(srvQueueDispatcher));
    this.callbackMap.set(SocketChannel.HELPDESK, srvHelpdeskDispatcher.handleMessage.bind(srvHelpdeskDispatcher));
    this.callbackMap.set(SocketChannel.CONFIRMATION, srvHelpdeskDispatcher.handleMessage.bind(srvHelpdeskDispatcher));
    this.callbackMap.set(SocketChannel.SYSTEM, srvHelpdeskDispatcher.handleMessage.bind(srvHelpdeskDispatcher)); // If channel is empty, send to Helpdesk
  }

  public deliverMessage(data: SocketMessage) {

    logger.debug("SocketMessageService: deliverMessage", data);

    let channel: SocketChannel = this.getMessageChannel(data.message);
    
    let callback = this.getCallbackHandler(channel); 
    callback(data);
  }
  
  private getMessageChannel(msg: string): SocketChannel {

    logger.debug(`SocketMessageService: getMessageChannel`, msg);

    let strChatItemMsg = msg.split('#');
    let strChatItemHeader = strChatItemMsg[0];

    let arrHeaders = strChatItemHeader.split(";")
    for (let i = 0; i < arrHeaders.length; i++) {
      let detail = arrHeaders[i].split(':')
      if (detail.length == 2) {
        let name = detail[0];
        let value = detail[1];
        if (name == "ch") return value as SocketChannel;
      }
    }
    return SocketChannel.SYSTEM;
  }

  private getCallbackHandler(channel: SocketChannel): Function{
    let handler = this.callbackMap.get(channel);
    if (handler) {
      return handler;
    } else {
      return this.deadLetterHandler.bind(this);
    }
  }

  public deadLetterHandler(data: SocketMessage) {
    logger.info(`DeadLetter Handler: ${data.message}`);
  }
}
